class form {
	constructor(config) {
		this.config = Object.assign({
			scope: '.donation-form',
			moduleId: null
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.modifyFormAction();
	}

	modifyFormAction() {
		const $form = this.$scope.find('form');
		if ($form.length > 0) {
			$form.attr('action', this.$scope.data('action'));
			$form.attr('id', '');
			$form.attr('enctype', '');
			$form.attr('accept-charset', '');

			const $hiddenInput = $('<input>').attr({
				type: 'hidden',
				name: 'action',
				value: 'donatie'
			});

			$form.append($hiddenInput);
		}
	}
}

export default new form;